var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { styled } from '@mui/material/styles';
import Link from '@mui/material/Link';
const StyledLink = styled(Link, {
    shouldForwardProp: (prop) => !['bdsFontSize'].includes(prop)
})(({ theme, bdsFontSize = 'default' }) => ({
    fontFamily: theme.palette.link.font.family,
    fontWeight: theme.palette.link.font.weight,
    letterSpacing: theme.palette.link.font.letterSpacing,
    fontSize: theme.palette.link.font[bdsFontSize].size,
    lineHeight: theme.palette.link.font[bdsFontSize].lineHeight,
    backgroundColor: theme.palette.link.background.default,
    color: theme.palette.link.text.default,
    textDecorationColor: theme.palette.link.text.default,
    '&:hover': {
        color: theme.palette.link.text.hover,
        backgroundColor: theme.palette.link.background.hover,
        textDecorationColor: theme.palette.link.text.hover
    },
    '&:focus': {
        color: theme.palette.link.text.focus,
        backgroundColor: theme.palette.link.background.focus
    },
    '&:disabled': {
        color: theme.palette.link.text.disabled,
        backgroundColor: theme.palette.link.background.disabled
    },
    '&:visited': {
        textDecoration: theme.palette.link.text.visited
    }
}));
const BDSLink = forwardRef((_a, ref) => {
    var { bdsFontSize, children, underline = 'hover', opensInNewTabOrWindow = false } = _a, rest = __rest(_a, ["bdsFontSize", "children", "underline", "opensInNewTabOrWindow"]);
    const target = opensInNewTabOrWindow ? '_blank' : '_top';
    const rel = opensInNewTabOrWindow ? 'noopener noreferrer' : undefined;
    return (React.createElement(StyledLink, Object.assign({ bdsFontSize: bdsFontSize, ref: ref, underline: underline, target: target, rel: rel }, rest), children));
});
// This is necessary to show the name of the component
// correctly in the DevTools and Storybook.
BDSLink.displayName = 'Link';
export default BDSLink;
//# sourceMappingURL=Link.js.map